module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8587/img/InterstitialBlobs.png"